export default "__VITE_ASSET__D4CDAAT1__"